import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  Pipe,
  PipeTransform,
  TemplateRef,
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import { from, interval, Observable } from "rxjs";
import { filter, map, takeWhile } from "rxjs/operators";
import MarkerClusterer from "@googlemaps/markerclustererplus";
import {
  ClusterOptions,
  ClusterStyle,
} from "@agm/js-marker-clusterer/services/google-clusterer-types";
import {
  TravelMarker,
  TravelMarkerOptions,
  TravelData,
  TravelEvents,
  EventType,
} from "travel-marker";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";

import { PDFfile } from "src/app/device/PDFfile";
import { NavigationStart, Router } from "@angular/router";
import { TraslateService } from "src/app/traslate.service";
import { HttpClient } from "@angular/common/http";
import { SelectionModel } from "@angular/cdk/collections";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatDialog } from "@angular/material/dialog";
import { GoogleMapsAPIWrapper } from "@agm/core";
import { environment } from "src/environments/environment";
import { Location } from "@angular/common";
import { url } from "inspector";
import { NgxSpinnerService } from "ngx-spinner";
import { NotificationsService } from "angular2-notifications";
import { threadId } from "worker_threads";
import { HttpErrorResponse, HttpHeaders } from "@angular/common/http";

declare var google: any;

export interface dataScore {
  name: string;
  x: number;
  y: number;
  z: number;
}

export interface PeriodicElementfilter {
  name: string;
  position: number;
  weight: number;
  weight1: number;
  weight2: number;
  pushed_at: Date;
  created_at: Date;
}

@Component({
  selector: "app-user-vehicule-det",
  templateUrl: "./user-vehicule-det.component.html",
  styleUrls: ["./user-vehicule-det.component.scss"],
})
export class UserVehiculeDetComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  history_trajet = null;

  tableDataSource: any;

  icon: any = {
    url: "assets/icons/map-marker.svg",
    scaledSize: { width: 50, height: 50 },
  };
  iconStart: any = {
    url: "assets/icons/green-flag.svg",
    scaledSize: { width: 50, height: 50 },
  };
  iconEnd: any = {
    url: "assets/icons/red-flag.svg",
    scaledSize: { width: 50, height: 50 },
  };
  iconScore1: any = {
    url: "assets/icons/alert_warning.png",
    scaledSize: { width: 40, height: 40 },
  };
  iconScore2: any = {
    url: "assets/icons/warning_accident.png",
    scaledSize: { width: 40, height: 40 },
  };
  iconScore3: any = {
    url: "assets/icons/alert_warning.png",
    scaledSize: { width: 40, height: 40 },
  };
  iconScore4: any = {
    url: "assets/icons/transit-car-accident.svg,scaledSize: {width: 40, height: 40}",
  };
  iconScore5: any = {
    url: "assets/icons/barriere.png",
    scaledSize: { width: 40, height: 40 },
  };

  lengthpage: number = 100;
  pageSizeOptions1: number[];
  pageNum: any;
  manualPage: number = 0;
  colormarker = "#1155cc";
  manualPage1: number;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25];
  pageSize1: any;
  pageSize: any = 2;
  index2: any = 5;
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean;
  ItemSelected: any[];

  highlighted = false;
  selectedRowIndex: number = -1;

  displayedColumns = [
    "id",
    "Manoeuvres",
    "maneuver_start",
    "maneuver_type",
    "avg_speed",
    "max_speed",
    "maneuver_duration",
    "risk_score",
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: "0px", y: "0px" };
  CodePostal: any;
  Nom: any;
  Groupe: any;
  myModel = true;
  veh: boolean = true;
  scr: boolean = true;
  typeMapIdSelect: any = "satellite";
  tableDataSourceContact: any;
  locationData: any[];
  data: any;
  dataPosition: any;
  simulation: boolean = false;
  URL: string;
  URL1: string;
  orderId: any;
  trip_start: any;
  trip_end: any;
  trip_duration: any;
  safety_score: any;
  eco_score: any;
  idle_time: any;
  unit: any;
  driver: any;
  km_between_maneuvers: any;
  safety_score_tendency: any;
  eco_score_tendency: any;
  avg_speed: any;
  max_speed: any;
  avg_idle_time: any;
  firstLong: any;
  firstLat: any;
  lat: any = 31.628674;
  lng: any = -7.992047;
  dataPosition2: any;
  tableDataSource1: any;
  distance: any;
  simulationAccident: boolean = false;
  line2: any;
  line3: any;
  line4: any;
  dataDetailsTrajets: any;
  offset: number = 0;
  repos: any;
  tripStatistics: any;

  manoeuvre_id: any;
  manoeuvre_idd: any;
  filterValue: string;
  idVehicule: any = localStorage.getItem("id_Vehicule");
  idConducteur: any = localStorage.getItem("id_Conducteur");
  typeDePage: any = this.location.path().split("/")[2];
  offsetPagination: any = 0;
  trajet_history_conductor: any;
  tripStatistics_conductor: any;
  data_conductor: any;

  constructor(
    private _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private http: HttpClient,
    public traslateService: TraslateService,
    private router: Router,
    private location: Location,
    private spinnerVehiculeTrajet: NgxSpinnerService
  ) {
    this.filterValue = localStorage.getItem("filterValue");

    this.manoeuvre_id = localStorage.getItem("id_manoeuvre");
  }

  changeTypeMap(e) {
    this.typeMapIdSelect = e;
  }

  ngOnInit() {
    this.history_trajet = JSON.parse(localStorage.getItem("trajet_history"));

    if (typeof this.history_trajet.search_from == "undefined") {
      this.URL =
        environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/vehicles/" +
        localStorage.getItem("id_Vehicule") +
        "/trips/" +
        this.location.path().split("/")[4] +
        "/date/" +
        this.history_trajet.trip_start +
        "~" +
        this.history_trajet.trip_end +
        "?page=1";
    } else {
      this.URL =
        environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/vehicles/" +
        localStorage.getItem("id_Vehicule") +
        "/trips/" +
        this.location.path().split("/")[4] +
        "/date/" +
        this.history_trajet?.search_from +
        "~" +
        this.history_trajet.search_to +
        "?page=1" +
        "&search=_" +
        this.history_trajet.search;
    }
    this.trajet_history_conductor = JSON.parse(
      localStorage.getItem("trajet_history_conductor")
    );
    this.URL1 =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/drivers/" +
      localStorage.getItem("id_Conducteur") +
      "/trips/" +
      this.location.path().split("/")[4] +
      "/date/" +
      this.trajet_history_conductor?.trip_start +
      "~" +
      this.trajet_history_conductor?.trip_end +
      "?page=1";

    if (this.location.path().split("/")[2] == "vehicule") {
      this.spinnerVehiculeTrajet.show();
      this.http.get<any>(this.URL).subscribe(
        (data) => {
          this.dataDetailsTrajets = data.data;
          this.tripStatistics = data.tripStatistics;

          this.trip_start = this.tripStatistics?.trip_start;
          this.trip_end = this.tripStatistics?.trip_end;
          this.trip_duration = this.tripStatistics?.trip_duration;
          this.distance = this.tripStatistics?.distance_traveled;
          this.idle_time = this.tripStatistics?.idle_time;
          this.safety_score = this.tripStatistics?.safety_score;
          this.eco_score = this.tripStatistics?.eco_score;
          this.unit = this.tripStatistics?.unit;
          this.driver = this.tripStatistics?.driver;
          this.avg_idle_time = this.tripStatistics?.avg_idle_time + "%";
          this.km_between_maneuvers =
            this.tripStatistics?.km_between_maneuvers + "Km";
          this.safety_score_tendency =
            this.history_trajet?.safety_score_tendency;
          this.eco_score_tendency = this.history_trajet?.eco_score_tendency;
          this.avg_speed = this.tripStatistics?.avg_speed;
          this.max_speed = this.tripStatistics?.max_speed;
          this.firstLong = this.tripStatistics?.init_long;
          this.firstLat = this.tripStatistics?.init_lat;
          this.lat = this.firstLat;
          this.lng = this.firstLong;
          // @ts-ignore
          this.repos = data?.data;
          // @ts-ignore
          this.repos?.length = data?.total;

          //(event.target as HTMLInputElement).value
          const filterValue = localStorage.getItem("filterValue");
          this.dataSource.filter = filterValue.trim().toLowerCase();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          this.dataSource = new MatTableDataSource(data.data);
          this.spinnerVehiculeTrajet.hide();
          if (data.maneuvers) {
            this.tableDataSource = data.maneuvers;
          }

          this.tableDataSourceContact = data?.data;
          this.dataSource.paginator = this.paginator;
          this.manoeuvre_idd = this.tableDataSource?.maneuver_id;
          var lgn: any = this.tableDataSource?.length;
          this.lengthpage = parseInt("" + (lgn + 1) / this.pageSize);

          //Create dummy data
          for (var i = 0; i < this.lengthpage + 1; i++) {
            this.collection.push(i + 1);
          }

          let man = [];
          this.tableDataSourceContact?.forEach((e) => {
            if (e.maneuver_id == this.manoeuvre_id) {
              this.openWindow(e.id, e.lat, e.long);
              return;
            } else {
              return;
            }
          });
          this.spinnerVehiculeTrajet.hide();
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Un problème est survenu! " + error,
          });

          this.spinnerVehiculeTrajet.hide();
        }
      );
    } else {
      this.spinnerVehiculeTrajet.show();
      this.http.get<any>(this.URL1).subscribe(
        (data) => {
          this.tripStatistics_conductor = data.tripStatistics;
          this.data_conductor = data.data;

          this.trip_start = this.tripStatistics_conductor?.trip_start;
          this.trip_end = this.tripStatistics_conductor?.trip_end;
          this.trip_duration = this.tripStatistics_conductor?.trip_duration;
          this.distance = this.tripStatistics_conductor?.distance_traveled;
          this.idle_time = this.tripStatistics_conductor?.idle_time;
          this.safety_score = this.tripStatistics_conductor?.safety_score;
          this.eco_score = this.tripStatistics_conductor?.eco_score;
          this.unit = this.tripStatistics_conductor?.unit;
          this.driver = this.tripStatistics_conductor?.driver;
          this.avg_idle_time = this.tripStatistics_conductor?.avg_idle_time;
          this.km_between_maneuvers =
            this.tripStatistics_conductor?.km_between_maneuvers;
          this.safety_score_tendency =
            this.tripStatistics_conductor?.safety_score_tendency;
          this.eco_score_tendency =
            this.tripStatistics_conductor?.eco_score_tendency;
          this.avg_speed = this.tripStatistics_conductor?.avg_speed;
          this.max_speed = this.tripStatistics_conductor?.max_speed;
          this.firstLong = this.tripStatistics_conductor.init_long;
          this.firstLat = this.tripStatistics_conductor.init_lat;
          this.lat = this.firstLat;
          this.lng = this.firstLong;
          // @ts-ignore
          this.repos = data?.data;
          // @ts-ignore
          this.repos?.length = data?.total;

          this.dataSource = new MatTableDataSource(data.data);
          console.log(data.data);
          this.tableDataSource = data.data;

          this.tableDataSourceContact = data.data;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.manoeuvre_idd = this.tableDataSource.maneuver_id;

          this.collection = [];
          var lgn: any = this.tableDataSource.length;
          this.lengthpage = parseInt("" + (lgn + 1) / this.pageSize);

          //Create dummy data
          for (var i = 0; i < this.lengthpage + 1; i++) {
            this.collection.push(i + 1);
          }

          let man = [];
          this.tableDataSourceContact.forEach((e) => {
            if (e.maneuver_id == this.manoeuvre_id) {
              this.openWindow(e.id, e.lat, e.long);
              return;
            } else {
              return;
            }
          });
          this.spinnerVehiculeTrajet.hide();
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Un problème est survenu! " + error,
          });

          this.spinnerVehiculeTrajet.hide();
        }
      );
    }

    this.drawPath();
    this.clusterStyles = [
      {
        textColor: "#FFFFFF",
        url: "https://raw.githubusercontent.com/mikesaidani/marker-clusterer-plus/master/images/m1.png",
        height: 50,
        width: 50,
      },
      {
        textColor: "#FFFFFF",
        url: "https://raw.githubusercontent.com/mikesaidani/marker-clusterer-plus/master/images/m2.png",
        height: 50,
        width: 50,
      },
    ];

    this.clusterOptions = {
      gridSize: 50,
      minimumClusterSize: 5,
      averageCenter: true,
      maxZoom: 50,
      styles: this.clusterStyles,
    };
  }

  getNextData(currentSize, offset, limit) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.offsetPagination = parseInt(offset) + 1;

    if (typeof this.history_trajet.search_from == "undefined") {
      this.URL =
        environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/vehicles/" +
        localStorage.getItem("id_Vehicule") +
        "/trips/" +
        this.location.path().split("/")[4] +
        "/date/" +
        this.history_trajet.trip_start +
        "~" +
        this.history_trajet.trip_end +
        "?page=" +
        this.offsetPagination;
    } else {
      this.URL =
        environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/drivers/" +
        localStorage.getItem("id_Conducteur") +
        "/trips/" +
        this.location.path().split("/")[4] +
        "/date/" +
        this.trajet_history_conductor.trip_start +
        "~" +
        this.trajet_history_conductor.trip_end +
        "?page" +
        this.offsetPagination;
    }
    this.http.get(this.URL).subscribe((response) => {
      // @ts-ignore
      // @ts-ignore
      this.repos.length = currentSize;
      // @ts-ignore
      this.repos.push(...response.data);
      // @ts-ignore
      this.repos.length = response.total;
      this.dataSource = new MatTableDataSource<any>(this.repos);
      this.dataSource._updateChangeSubscription();
      this.dataSource.paginator = this.paginator;
    });
  }

  pageChanged(event) {
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;
    let previousIndex = event.previousPageIndex;
    let previousSize = pageSize * pageIndex;
    this.getNextData(previousSize, pageIndex.toString(), pageSize.toString());
  }

  clickzoom(e1, e2, e3) {
    this.zoom = e1;
    this.lat = e2;
    this.lng = e3;
  }

  getIcon(e, e1) {
    if (e < 55 && e > 0) {
      return this.iconScore1;
    } else if (e < 76 && e > 54) {
      return this.iconScore2;
    } else if (e > 75) {
      return this.iconScore3;
    } else if (e == null && e1 === "Accident") {
      return this.iconScore4;
    } else if (e == null && e1 === "Inactivité") {
      return this.iconScore5;
    }
  }

  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: item };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
  }

  onContextMenuAction1(item: any) {
    alert(`Click on Supprimer for ${item.name}`);
  }

  onContextMenuAction2(item: any) {
    alert(`Click on Modifier for ${item.name}`);
  }

  onContextMenuAction3(item: any) {
    alert(`Click on Activer/Désactiver for ${item.name}`);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          this.selection.select(row);
        });
  }

  map: any;
  searchBox: any;

  onMouseOver(infoWindow, $event: google.maps.MouseEvent) {
    infoWindow.open();
  }

  onMouseOut(infoWindow, $event: MouseEvent) {
    infoWindow.close();
  }

  mapReady(event: any) {
    this.map = event;
    const input = document.getElementById("Map-Search");
    this.searchBox = new google.maps.places.SearchBox(input);
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(
      document.getElementById("Settings")
    );
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(
      document.getElementById("Profile")
    );
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
    this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
      document.getElementById("Logout")
    );

    this.searchBox.addListener("places_changed", () =>
      this.goToSearchedPlace()
    );
  }

  goToSearchedPlace() {
    const places = this.searchBox.getPlaces();
    if (places.length === 0) {
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    places.forEach((place) => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    this.map.fitBounds(bounds);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;
    }
  }

  //filtre global

  applyFilter(event: Event) {
    this.dataSource = new MatTableDataSource(this.tableDataSource);
    //
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
    localStorage.setItem("filterValue", filterValue);
  }

  ngAfterViewInit() {}

  collection: any = [];

  exportPDF() {
    window.print();
  }

  exportExcel(e, e2) {
    Swal.fire({
      title: "Souhaitez-vous  exporter la table type ." + e2 + " ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Exporter Fichier !",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Export!", "Le fichier est exporté.", "success");
        e.exportTable(e2, {
          fileName: "STG_DRIVE_conducteurs_date_" + new Date().toLocaleString(),
          sheet: "STG DRIVE conducteurs",
          Props: { Author: "STG_DRIVE" },
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "file not exported :)", "error");
      }
    });
  }

  updateColor(progress) {
    if (progress > 75) {
      return "#78C000";
    } else if (progress >= 55) {
      return "#FD7F20";
    } else {
      return "#EB0000";
    }
  }

  clusterStyles: ClusterStyle[];
  clusterOptions: ClusterOptions;
  icon1: any = {
    url: "http://earth.google.com/images/kml-icons/track-directional/track-4.png",
    scaledSize: {
      width: 30,
      height: 30,
    },
  };

  // google maps zoom level
  zoom: any = 10;
  openedWindow: number = 0; // alternative: array of numbers

  // initial center position for the map

  zoomPosition(e1, e2, e3, infoWindow, $event: google.maps.MouseEvent) {
    this.lat = e1;
    this.lng = e2;
    this.zoom = e3;
    infoWindow.open();
  }

  openWindow(id, e2, e3) {
    if (this.selectedRowIndex === id) {
      this.selectedRowIndex = -1;
      this.highlighted = false;
      this.openedWindow = -1;
      this.clickzoom(19, e2, e3);
    } else {
      this.highlighted = true;
      this.manoeuvre_id = -1;
      localStorage.setItem("id_manoeuvre", this.manoeuvre_id);
      this.selectedRowIndex = id;
      this.openedWindow = id;
      this.clickzoom(19, e2, e3);
    }
  }

  isInfoWindowOpen(id) {
    return this.openedWindow == id; // alternative: check if id is in array
  }

  markers: marker[] = [];

  calculateFunction(markers, numStyle: number) {
    let index: number = 0;
    let title: string = "ddfgdfg";
    let text: string =
      '<div style="position: relative; top: 2px; text-align: center; margin: 0px auto; width: 55px;"> <div style="display: inline-block; width: 32px;">{ELEMENTS}</div></div>';
    let qtdNodes: number = 0;
    let qtdEvents: number = 0;

    for (let i of markers) {
      qtdNodes += i.zIndex;
      qtdEvents += i.zIndex;
    }

    index = qtdEvents == 5 ? 1 : 2;

    text = text.replace("{ELEMENTS}", qtdNodes.toString());
    text = text.replace("{PROBLEMS}", qtdEvents.toString());

    return {
      text: text,
      index: index,
    };
  }

  arr = [];
  arr2 = [];

  drawPath() {
    this.markers.splice(0, this.markers.length);
    if (typeof this.history_trajet.search_from == "undefined") {
      this.URL =
        environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/vehicles/" +
        localStorage.getItem("id_Vehicule") +
        "/trips/" +
        this.location.path().split("/")[4] +
        "/date/" +
        this.history_trajet?.trip_start +
        "~" +
        this.history_trajet?.trip_end +
        "/map";
    } else {
      this.URL =
        environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/vehicles/" +
        localStorage.getItem("id_Vehicule") +
        "/trips/" +
        this.location.path().split("/")[4] +
        "/date/" +
        this.history_trajet?.search_from +
        "~" +
        this.history_trajet?.search_to +
        "/map";
    }
    this.URL1 =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/drivers/" +
      localStorage.getItem("id_Conducteur") +
      "/trips/" +
      this.location.path().split("/")[4] +
      "/date/" +
      this.trajet_history_conductor?.trip_start +
      "~" +
      this.trajet_history_conductor?.trip_end +
      "/map";
    //this.URL = environment.apiUrl + "/companies/" + JSON.parse(localStorage.getItem('currentUser')).company_id + "/vehicles/" + localStorage.getItem('id_Vehicule') + "/trips/" + this.location.path().split('/')[4]+"/map"
    //this.URL1 = environment.apiUrl + "/companies/" + JSON.parse(localStorage.getItem('currentUser')).company_id + "/drivers/" + localStorage.getItem('id_Conducteur') + "/trips/" + this.location.path().split('/')[4]+"/map"
    if (this.location.path().split("/")[2] == "vehicule") {
      this.spinnerVehiculeTrajet.show();
      this.http.get<any>(this.URL).subscribe(
        (data): any => {
          this.tableDataSource = data;
          this.tableDataSource?.forEach((element) => {
            var position: marker = {
              lat: element.lat,
              long: element.long,
            };
            this.arr.push([element.lat, element.long]);
            this.arrayPosition(this.arr);
            this.markers.push(position);
          });
          if (!data.length) this.zoom = 6;
          this.spinnerVehiculeTrajet.hide();
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Un problème est survenu! " + error,
          });

          this.spinnerVehiculeTrajet.hide();
        }
      );
    } else {
      this.spinnerVehiculeTrajet.show();
      this.http.get<any>(this.URL1).subscribe(
        (data) => {
          var dataDetailsTrajets: any = data;
          this.tableDataSource = data;

          let i = 0;

          const obs = this.tableDataSource?.forEach((element) => {
            var position: marker = {
              lat: element.lat,
              long: element.long,
            };
            this.arr.push([element.lat, element.long]);
            this.arrayPosition(this.arr);
            this.markers.push(position);
          });

          this.spinnerVehiculeTrajet.hide();
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Un problème est survenu! " + error,
          });

          this.spinnerVehiculeTrajet.hide();
        }
      );
    }
  }

  getPositionCrash(e, orientation, typeCrash, parking, id) {
    if (e === "Accident") {
      localStorage.setItem("orientation", orientation);
      localStorage.setItem("typeCrash", typeCrash);
      localStorage.setItem("parking", parking);

      this.simulationAccident = true;
      this.arr2 = [];
      this.URL =
        environment.apiUrl +
        "/units/" +
        localStorage.getItem("id_Vehicule") +
        "/crashes/" +
        id;
      this.spinnerVehiculeTrajet.show();
      this.http.get<any>(this.URL).subscribe(
        (data) => {
          this.traslateService.crashCoordonnées.next(data);
          this.tableDataSource1 = data;
          let i = 0;
          const obs = this.tableDataSource1.forEach((element) => {
            var position: marker = {
              lat: element.lat,
              long: element.long,
            };
            var obj = [element.lat, element.long];

            this.arr2.push(obj);
            this.arrayPosition2(this.arr2);
          });
          this.spinnerVehiculeTrajet.hide();
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Un problème est survenu! " + error,
          });
          this.simulationAccident = false;
          this.spinnerVehiculeTrajet.hide();
        }
      );
    } else {
      this.simulationAccident = false;
    }
  }

  arrayPosition2(e) {
    this.dataPosition2 = e;
  }

  arrayPosition(e) {
    this.dataPosition = e;
  }

  // google maps zoom level
  zoom1: number = 19;

  // initial center position for the map
  lat1: number = 51.512802;
  lng1: number = -0.091324;

  line: any;
  directionsService: any;
  marker: TravelMarker = null;

  // speedMultiplier to control animation speed
  speedMultiplier = 1;
  route: any;
  routeJSON: string;

  onMapReady(map: any) {
    this.map = map;
    // this.calcRoute();
    this.mockDirections();
    // this.initEvents();
  }

  onMapReadyTraffic($event) {
    let trafficLayer = new google.maps.TrafficLayer();

    trafficLayer.setMap($event);
  }

  desactiveSimulation() {
    this.simulation = false;
  }

  // mock directions api
  mockDirections() {
    this.simulation = true;
    this.locationData = this.dataPosition2;
    const locationArray = this.locationData.map(
      (l) => new google.maps.LatLng(l[0], l[1])
    );
    this.line = new google.maps.Polyline({
      strokeColor: "#4285f4",
      strokeOpacity: 0.9,
      path: "'FORWARD_CLOSED_ARROW'",
      map: this.map,
      icons: [
        {
          icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW },
          offset: "100%",
          repeat: "40px",
        },
      ],
    });

    this.line2 = new google.maps.Polyline({
      strokeColor: "#f4e242",
      strokeOpacity: 0.9,
      path: "'FORWARD_CLOSED_ARROW'",
      map: this.map,
      icons: [
        {
          icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW },
          offset: "100%",
          repeat: "40px",
        },
      ],
    });

    this.line3 = new google.maps.Polyline({
      strokeColor: "#f44263",
      strokeOpacity: 0.9,
      path: "'FORWARD_CLOSED_ARROW'",
      map: this.map,
      icons: [
        {
          icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW },
          offset: "100%",
          repeat: "40px",
        },
      ],
    });

    this.line4 = new google.maps.Polyline({
      strokeColor: "#d342f4",
      strokeOpacity: 0.9,
      path: "'FORWARD_CLOSED_ARROW'",
      map: this.map,
      icons: [
        {
          icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW },
          offset: "100%",
          repeat: "40px",
        },
      ],
    });
    locationArray.slice(0, 15).forEach((l) => {
      this.line.getPath().push(l);
    });

    locationArray.slice(14, 18).forEach((l) => {
      this.line2.getPath().push(l);
    });

    locationArray.slice(17, 21).forEach((l) => {
      this.line3.getPath().push(l);
    });

    locationArray.slice(20, 50).forEach((l) => {
      this.line4.getPath().push(l);
    });

    const start = new google.maps.LatLng(30.127371, -9.553743);
    const end = new google.maps.LatLng(30.12789, -9.553405);

    const startMarker = new google.maps.Marker({
      position: start,
      map: this.map,
      icon: this.iconStart,
    });
    const endMarker = new google.maps.Marker({
      position: end,
      map: this.map,
      icon: this.iconEnd,
    });

    this.initRoute();
  }

  // initialize travel marker
  initRoute() {
    this.route = this.line.getPath()?.getArray();
    this.routeJSON = JSON.stringify(this.route);

    //show marker in simulation
    let i = 0;
    const obs = interval(2000)
      .pipe(takeWhile((v) => i < this.locationData.length))
      .subscribe(() => {
        const pos = this.tableDataSource1[i];
        new google.maps.Marker({
          position: new google.maps.LatLng(
            this.locationData[i][0],
            this.locationData[i][1]
          ),
          map: this.map,
          label: "B",
        });
        i++;
      });

    const options: TravelMarkerOptions = {
      map: this.map, // map object
      speed: 50, // default 10 , animation speed
      interval: 10, // default 10, marker refresh time
      speedMultiplier: this.speedMultiplier,
      cameraOnMarker: true,

      markerOptions: {
        title: "Travel Marker",
        animation: google.maps.Animation.DROP,
        icon: {
          url: "https://i.imgur.com/eTYW75M.png",
          // This marker is 20 pixels wide by 32 pixels high.
          animation: google.maps.Animation.DROP,
          // size: new google.maps.Size(256, 256),
          scaledSize: new google.maps.Size(128, 128),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          anchor: new google.maps.Point(53, 110),
        },
      },
    };
    this.marker = new TravelMarker(options);

    // add locations from direction service
    this.marker.addLocation(this.route);
    setTimeout(() => {
      this.marker.setSpeedMultiplier(this.speedMultiplier);
      this.play();
    });
  }

  // play animation
  play() {
    this.marker?.play();
  }

  // pause animation
  pause() {
    this.marker?.pause();
  }

  // reset animation
  reset() {
    this.marker?.reset();
  }

  // jump to next location
  next() {
    this.marker?.next();
  }

  // jump to previous location
  prev() {
    this.marker?.prev();
  }

  // fast forward
  fast() {
    this.speedMultiplier *= 2;
    this.marker?.setSpeedMultiplier(this.speedMultiplier);
  }

  // slow motion
  slow() {
    this.speedMultiplier /= 2;
    this.marker?.setSpeedMultiplier(this.speedMultiplier);
  }

  initEvents() {
    this.marker?.event?.onEvent((event: EventType, data: TravelData) => {});
  }

  openDialog() {
    this.dialog.open(MapDetailCrash, {
      data: {
        animal: "panda",
      },
      width: "70%",
      height: "65%",
      autoFocus: false,

      panelClass: "my-custom-dialog-class",
    });
  }
}

interface marker {
  lat: number;
  long: number;
}

@Component({
  selector: "mapDetailCrash",
  templateUrl: "mapDetailCrash.html",
  styleUrls: ["./mapDetailCrash.scss"],
})
export class MapDetailCrash {
  locationData = [];
  // google maps zoom level
  zoom: number = 14;

  map: any;
  line: any;
  directionsService: any;
  marker: TravelMarker = null;

  // speedMultiplier to control animation speed
  speedMultiplier = 1;
  line2: any;
  line3: any;
  marker2: TravelMarker;
  marker3: TravelMarker;
  iconTravel: string = "https://i.imgur.com/eTYW75M.png";
  options3: TravelMarkerOptions;
  options2: TravelMarkerOptions;
  options: TravelMarkerOptions;
  line11: any;
  line111: any;
  line4: any;
  typeMapIdSelect: any = "satellite";

  public darkStyle = [
    {
      elementType: "geometry",
      stylers: [
        {
          hue: "#ff4400",
        },
        {
          saturation: -100,
        },
        {
          lightness: -4,
        },
        {
          gamma: 0.72,
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry",
      stylers: [
        {
          hue: "#0077ff",
        },
        {
          gamma: 3.1,
        },
      ],
    },
    {
      featureType: "water",
      stylers: [
        {
          hue: "#000000",
        },
        {
          gamma: 0.44,
        },
        {
          saturation: -33,
        },
      ],
    },
    {
      featureType: "poi.park",
      stylers: [
        {
          hue: "#44ff00",
        },
        {
          saturation: -23,
        },
      ],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [
        {
          hue: "#007fff",
        },
        {
          gamma: 0.77,
        },
        {
          saturation: 65,
        },
        {
          lightness: 99,
        },
      ],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [
        {
          gamma: 0.11,
        },
        {
          weight: 5.6,
        },
        {
          saturation: 99,
        },
        {
          hue: "#0091ff",
        },
        {
          lightness: -86,
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          lightness: -48,
        },
        {
          hue: "#ff5e00",
        },
        {
          gamma: 1.2,
        },
        {
          saturation: -23,
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "labels.text.stroke",
      stylers: [
        {
          saturation: -64,
        },
        {
          hue: "#ff9100",
        },
        {
          lightness: 16,
        },
        {
          gamma: 0.47,
        },
        {
          weight: 2.7,
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#3b5876",
        },
      ],
    },
  ];
  style: any = this.darkStyle;
  public defaultStyle = [];
  dataCrash: any;
  arr2: any = new Array();
  start: any;
  end: any;
  startend: any;
  endIcon: any;
  accidentStart: any;
  accidentEnd: any;
  locationArray: any[];
  speed: number = 50;

  constructor(
    private http: HttpClient,
    public traslateService: TraslateService,
    private spinnerVehiculeTrajet: NgxSpinnerService,
    private _snackBar: MatSnackBar,
    private _service: NotificationsService
  ) {
    this.dataMap();
  }

  dataMap() {
    this.arr2 = [];
    this.traslateService.crashdata.subscribe((response) => {
      var objectArray: any = Object.values(response);
      this.arr2 = [];
      objectArray.forEach((element) => {
        var obj = [
          parseFloat(element.lat),
          parseFloat(element.long),
          element.course,
        ];

        this.arr2.push(obj);
      });
      this.locationData = this.arr2;
      this.start = this.arr2.slice(0, 1)[0][0];
      this.end = this.arr2.slice(0, 1)[0][1];
      this.startend = this.arr2.slice(49, 50)[0][0];
      this.endIcon = this.arr2.slice(49, 50)[0][1];
      this.accidentStart = this.arr2.slice(20, 21)[0][0];
      this.accidentEnd = this.arr2.slice(20, 21)[0][1];
    });
  }

  changeTypeMap(e) {
    this.typeMapIdSelect = e;
  }

  changeStyleMap(e) {
    if (e === "darkStyle") {
      this.style = this.darkStyle;
    } else {
      this.style = this.defaultStyle;
    }
  }

  onMapReady(map: any) {
    this.map = map;

    // this.calcRoute();
    this.mockDirections();
    // this.initEvents();
  }

  /**
   *                  IMPORTANT NOTICE
   *  Google stopped its FREE TIER for Directions service.
   *  Hence the below route calculation will not work unless you provide your own key with directions api enabled
   *
   *  Meanwhile, for the sake of demo, precalculated value will be used
   */

  // get locations from direction service
  calcRoute() {
    this.line = new google.maps.Polyline({
      strokeOpacity: 0.5,
      path: [],
      map: this.map,
    });
    this.line2 = new google.maps.Polyline({
      strokeOpacity: 0.5,
      path: [],
      map: this.map,
    });

    this.line3 = new google.maps.Polyline({
      strokeOpacity: 0.5,
      path: [],
      map: this.map,
    });
    const start = new google.maps.LatLng(this.start, this.end);
    const end = new google.maps.LatLng(this.startend, this.endIcon);
    const request = {
      origin: start,
      destination: end,
      travelMode: google.maps.TravelMode.BICYCLING,
    };
    this.directionsService = new google.maps.DirectionsService();
    this.directionsService.route(request, (response, status) => {
      // Empty response as API KEY EXPIRED
      if (status == google.maps.DirectionsStatus.OK) {
        var legs = response.routes[0].legs;
        for (let i = 0; i < legs.length; i++) {
          var steps = legs[i].steps;
          for (let j = 0; j < steps.length; j++) {
            var nextSegment = steps[j].path;
            for (let k = 0; k < nextSegment.length; k++) {
              this.line.getPath().push(nextSegment[k]);
              this.line2.getPath().push(nextSegment[k]);
              this.line3.getPath().push(nextSegment[k]);
            }
          }
        }
        this.initRoute();
      }
    });
  }

  async mockDirections() {
    this.locationArray = this.locationData.map(
      (l) => new google.maps.LatLng(l[0], l[1])
    );
    this.line = new google.maps.Polyline({
      strokeColor: "#22c1c3",
      strokeOpacity: 0.5,
      path: [],
      map: this.map,
    });

    this.line2 = new google.maps.Polyline({
      strokeColor: "#fc466b",
      strokeOpacity: 0.9,
      path: [],
      map: this.map,
    });

    this.line3 = new google.maps.Polyline({
      strokeColor: "#fc466b",
      strokeOpacity: 0.9,
      path: [],
      map: this.map,
    });
    this.line4 = new google.maps.Polyline({
      strokeColor: "#3b5876",
      strokeOpacity: 0.9,
      path: [],
      map: this.map,
    });

    await this.locationArray
      .slice(0, 50)
      .forEach((l) => setTimeout(this.line.getPath().push(l)));
    await this.locationArray
      .slice(18, 21)
      .forEach((l) => this.line2.getPath().push(l));
    await this.locationArray
      .slice(20, 22)
      .forEach((l) => this.line3.getPath().push(l));
    await this.locationArray
      .slice(21, 50)
      .forEach((l) => this.line4.getPath().push(l));

    this.initRoute();
  }

  initRoute() {
    const route = this.line.getPath().getArray();
    const route1 = this.line2.getPath().getArray();
    const route2 = this.line3.getPath().getArray();
    const route3 = this.line4.getPath().getArray();
    // options
    this.options = {
      map: this.map, // map object
      speed: 80, // default 10 , animation speed
      interval: 10, // default 10, marker refresh time
      speedMultiplier: this.speedMultiplier,
      markerType: "overlay",

      cameraOnMarker: true,
      overlayOptions: {
        offsetX: 0, // default: 0, x-offset for overlay
        offsetY: 0, // default: 0, y-offset for overlay
        offsetAngle: 90, // default: 0, rotation-offset for overlay
        imageUrl: "https://i.stack.imgur.com/lDrin.png",
        imageWidth: 36, // image width of overlay
        imageHeight: 58, // image height of overlay
      },

      markerOptions: {
        title: "Travel Marker",
        animation: google.maps.Animation.DROP,

        icon: {
          url: "https://cdn.icon-icons.com/icons2/429/PNG/512/car90_42507.png",
          // This marker is 20 pixels wide by 32 pixels high.
          animation: google.maps.Animation.DROP,
          // size: new google.maps.Size(256, 256),
          scaledSize: new google.maps.Size(40, 40),
          // The origin for this image is (0, 0).
        },
      },
    };
    this.options2 = {
      map: this.map, // map object
      speed: 80, // default 10 , animation speed
      interval: 10, // default 10, marker refresh time
      speedMultiplier: this.speedMultiplier,

      markerOptions: {
        title: "Travel Marker",

        icon: {
          url: "assets/accidentIcon.png",
          // This marker is 20 pixels wide by 32 pixels high.
          //animation: google.maps.Animation.DROP,
          // size: new google.maps.Size(256, 256),
          scaledSize: new google.maps.Size(50, 50),
        },
      },
    };
    this.options3 = {
      map: this.map, // map object
      speed: 80, // default 10 , animation speed
      interval: 10, // default 10, marker refresh time
      speedMultiplier: this.speedMultiplier,

      markerOptions: {
        title: "Travel Marker",
        // animation: google.maps.Animation.DROP,
        icon: {
          url: "assets/accidentBoom.gif",
          // This marker is 20 pixels wide by 32 pixels high.
          //animation: google.maps.Animation.DROP,
          // size: new google.maps.Size(256, 256),
          scaledSize: new google.maps.Size(100, 100),
        },
      },
    };
    // define markerOptions
    this.marker3 = new TravelMarker(this.options3);
    this.marker2 = new TravelMarker(this.options2);
    this.marker = new TravelMarker(this.options);
    this.marker?.addLocation(route);
    this.marker2?.addLocation(route2);
    this.marker3?.addLocation(route2);

    this.play();
  }

  ddt: any = [];

  // play animation
  play() {
    this.marker2.setMarkerOptions({ opacity: 0 });
    this.marker3.setMarkerOptions({ opacity: 0 });
    this.zoom = 20;
    this.marker?.play();
    this.marker.event.onEvent((event: EventType, data: TravelData) => {
      var dataTravel: any = data;
      if (dataTravel.index > 1 && dataTravel.index < 18) {
        var icon: any = {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
          scale: 3,
          scaledSize: new google.maps.Size(30, 30),
          strokeColor: "#3f7547",
          rotation:
            Number(JSON.stringify(this.locationData[data.index][2])) * -1,
        };
      } else if (dataTravel.index > 17 && dataTravel.index < 22) {
        var icon: any = {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
          scale: 3,
          scaledSize: new google.maps.Size(30, 30),
          strokeColor: "#cf4d3c",
          rotation:
            Number(JSON.stringify(this.locationData[data.index][2])) * -1,
        };
      } else {
        var icon: any = {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
          scale: 3,
          scaledSize: new google.maps.Size(30, 30),
          strokeColor: "#404ba3",
          rotation:
            Number(JSON.stringify(this.locationData[data.index][2])) * -1,
        };
      }

      new google.maps.Marker({
        position: {
          lat: Number(data.location.toString().replace("(", "").split(",")[0]),
          lng: Number(data.location.toString().replace(")", "").split(",")[1]),
        },
        map: this.map,
        title:
          "Rotation : " +
          Number(JSON.stringify(this.locationData[data.index][2])),
        icon: icon,
      });
      this.ddt.push(data.index);

      if (dataTravel.status == "playing") {
        this._snackBar.open("Simulation en cours!", "Fermer", {
          duration: 2000,
          horizontalPosition: "start",
          verticalPosition: "bottom",
        });
      }

      if (
        dataTravel.index > 1 &&
        dataTravel.index < 3 &&
        this.ddt.length == 1
      ) {
        var success = this._service.info(
          "Simulation Accident!",
          "Départ du trajet...",
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: false,
            clickIconToClose: true,
          }
        );
      } else if (dataTravel.index == 19) {
        this.marker.setSpeed(20);

        this.marker.setOverlayOptions({ opaciimageWidthty: 0 });

        this._snackBar.open("Accident", "Fermer", {
          duration: 2000,
          horizontalPosition: "start",
          verticalPosition: "bottom",
        });

        if (this.ddt.length == 18) {
          var success2 = this._service.error(
            "Simulation Accident!",
            "Accident...",
            {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: false,
              clickIconToClose: true,
            }
          );
          var success3 = this._service.error(
            "Parking!",
            localStorage.getItem("parking"),
            {
              timeOut: 3500,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: false,
              clickIconToClose: true,
            }
          );
          var success4 = this._service.error(
            "Orientation!",
            localStorage.getItem("orientation"),
            {
              timeOut: 4000,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: false,
              clickIconToClose: true,
            }
          );
          var success5 = this._service.error(
            "Type accident!",
            localStorage.getItem("typeCrash"),
            {
              timeOut: 4500,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: false,
              clickIconToClose: true,
            }
          );
        }
      } else if (dataTravel.index > 19) {
        this.marker3.setMarkerOptions({ opacity: 1 });

        this.marker2.setMarkerOptions({ opacity: 1 });

        if (dataTravel.index > 20) {
          this.marker3.setMarkerOptions({ opacity: 0 });

          this.marker.setSpeed(50);
        }

        this._snackBar.open(
          "Parking!" + localStorage.getItem("parking"),
          "Fermer",
          {
            duration: 2000,
            horizontalPosition: "start",
            verticalPosition: "bottom",
          }
        );

        this._snackBar.open(
          "Orientation!" + localStorage.getItem("orientation"),
          "Fermer",
          {
            duration: 2000,
            horizontalPosition: "start",
            verticalPosition: "bottom",
          }
        );

        this._snackBar.open(
          "Type accident!" + localStorage.getItem("typeCrash"),
          "Fermer",
          {
            duration: 2000,
            horizontalPosition: "start",
            verticalPosition: "bottom",
          }
        );
        // this.zoom = 20
        this._snackBar.open("Simulation en cours!", "Fermer", {
          duration: 2000,
          horizontalPosition: "start",
          verticalPosition: "bottom",
        });
      }

      if (dataTravel.status == "finished") {
        this._snackBar.open("Fin du simulation!", "Fermer", {
          duration: 2000,
          horizontalPosition: "start",
          verticalPosition: "bottom",
        });

        if (this.ddt.length == 48) {
          var success5 = this._service.warn(
            "Simulation Accident!",
            "Fin du trajet",
            {
              timeOut: 4500,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: false,
              clickIconToClose: true,
            }
          );
        }

        dataTravel = [];
      }
    });
  }

  // pause animation
  pause() {
    this.marker.pause();
    this._snackBar.open("Pause", "Fermer", {
      duration: 2000,
      horizontalPosition: "start",
      verticalPosition: "bottom",
    });
  }

  // reset animation
  reset() {
    this.marker.reset();
    this.marker2.reset();
    this.marker3.reset();

    this.marker.setOverlayOptions({ opaciimageWidthty: 0 });
    this.marker2.setOverlayOptions({ imageWidth: 0 });
    this.marker3.setOverlayOptions({ imageWidth: 0 });
    this.marker.setMarkerOptions({ opacity: 1 });
    this.marker3.setMarkerOptions({ opacity: 0 });
    this.marker2.setMarkerOptions({ opacity: 0 });
    this._snackBar.open("Réinitialisation de la simulation", "Fermer", {
      duration: 2000,
      horizontalPosition: "start",
      verticalPosition: "bottom",
    });
  }

  // jump to next location
  next() {
    this.marker.next();
    this.marker2.next();
    this.marker3.next();

    this._snackBar.open("Suivant!", "Fermer", {
      duration: 2000,
      horizontalPosition: "start",
      verticalPosition: "bottom",
    });
  }

  // jump to previous location
  prev() {
    this.marker.prev();
    this.marker2.prev();
    this.marker3.prev();

    this._snackBar.open("Précédent!", "Fermer", {
      duration: 2000,
      horizontalPosition: "start",
      verticalPosition: "bottom",
    });
  }

  // fast forward
  fast() {
    this.speedMultiplier *= 2;
    this.marker.setSpeedMultiplier(this.speedMultiplier);
  }

  // slow motion
  slow() {
    this.speedMultiplier /= 2;
    this.marker.setSpeedMultiplier(this.speedMultiplier);
  }

  initEvents() {
    this.marker.event.onEvent((event: EventType, data: TravelData) => {});
  }
}
